module.exports = __webpack_public_path__ + "img/dispose13.e36f3d4d.png";